import { addMinutes, format, getTime } from 'date-fns';
import { formatInTimeZone, fromZonedTime } from 'date-fns-tz';
import React from 'react';
import { useWatch } from 'react-hook-form';

import DatePicker from '@components/form/DatePicker/DatePicker';
import EditorForm from '@components/form/EditorForm/EditorForm';
import Tabs from '@components/uikit/Tabs/Tabs';

import useTranslation from '@hooks/useTranslation';

import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

import { ADD_AI_FIELDS } from '../../constants/schemaAddActionItem';
import style from './style.module.scss';

const StepAIDetails = ({ control }) => {
  const { t } = useTranslation();
  const { data: profileData } = useUserProfileQuery();

  const aiOptionValue = useWatch({ name: ADD_AI_FIELDS.OPTION, control });
  const aiInstPointValue = useWatch({ name: ADD_AI_FIELDS.INSTALLATION_POINT, control });

  const utcTime = formatInTimeZone(new Date(), 'UTC', 'yyyy/MM/dd HH:mm');
  const currentFacilityDateTime = addMinutes(utcTime, aiInstPointValue.facilityOffset * 60);

  const isTypeReportFailure = aiOptionValue === 'reportFailure';
  const urgenciesList = [
    { value: 3, key: 'critical', label: t('Critical') },
    { value: 2, key: 'high', label: t('High') },
    { value: 1, key: 'standard', label: t('Standard') },
  ];

  const filterPassedTime = (time) => {
    const selectedDate = new Date(time);

    return currentFacilityDateTime.getTime() > selectedDate.getTime();
  };

  return (
    <div className={style.stepAiDetails}>
      {isTypeReportFailure && (
        <DatePicker
          control={control}
          name={ADD_AI_FIELDS.APPROXIMATE_DATE}
          label={t('The approximate date and time of the failure')}
          dateFormat={`${profileData?.dateFormat.date} ${profileData?.dateFormat.time}`}
          maxDate={new Date()}
          filterTime={filterPassedTime}
          showMonthDropdown
          showYearDropdown
          showTimeSelect
          required
          isFacilityOffsetAdded
          timeCaption={format(getTime(currentFacilityDateTime), 'HH:mm')}
        />
      )}
      <div>
        <Tabs name={ADD_AI_FIELDS.URGENCY} control={control} tabsItems={urgenciesList} label={t('Urgency')} />
      </div>
      <EditorForm
        name={ADD_AI_FIELDS.DESCRIPTION}
        control={control}
        label={isTypeReportFailure ? 'Cause of the failure' : 'Description'}
        required
      />
    </div>
  );
};

export default StepAIDetails;
